module.exports = __webpack_public_path__ + "static/OP14-4990d55fbaeb3c46671b8dcbdf7ed6c0.png";